import { Table } from "@mantine/core";
import React, { useState } from "react";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import { withTranslation } from "react-i18next";
import Button from "../../../components/Button";
import Page from "../../../components/Page";
import NewEmployement from "./NewEmployement";
import Delete from "../../../assets/delete.svg";
import "./styles.css";
import edit from "../../../assets/edit.svg";
import * as moment from "moment";
import { backendUrl } from "../../../constants";
import { showNotification } from "@mantine/notifications";

const Index = ({ employmentData, setRefetch }) => {
  let createdBy = JSON.parse(localStorage.getItem("userData"));
  const [showModal, setShowModal] = useState(false);
  const [editId, setEditId] = useState("");
  const [editEmployment, setEditEmployment] = useState("");
  const [isEdit, setIsEdit] = useState(false);

  const deleteEmployment=async(id)=>{
    const data={
      userId:createdBy.id,
      employmentId:id  
    }
    const options = {
      method: "POST",
      headers: {
        Accept: "application/json",
        "content-type": "application/json",
      },
      body: JSON.stringify(data),
    };
    await fetch(`${backendUrl}user/deleteJobSeekerEmployment`, options)
      .then((response) => response.json())
      .then((response) => {
        showNotification({
          message: "Education Deleted Successfully",
          color: "green",
        });
        setRefetch((v) => !v);
      })
      .catch((err) => console.error(err));
  }
  const editHistory = (id,data) => {
    setShowModal(true);
    setEditId(id);
    setEditEmployment(data)
  };

  const rows =
    employmentData &&
    employmentData.map((element) => (
      <tr key={element.id}>
        <td>{element.employeer}</td>
        <td>{element.jobTitle}</td>
        <td>{new moment(element.startDate).format("DD MMM YYYY")}</td>
        <td>{new moment(element.endDate).format("DD MMM YYYY")}</td>
        <td className="d-flex gap-2 align-items-center">
          <img
            onClick={() => deleteEmployment(element.id)}
            src={Delete}
            width="20px"
            className="delete"
            alt="delete"
          />
          <img
            onClick={() => editHistory(element.id,element.data)}
            src={edit}
            width="20px"
            className="delete"
            alt="edit"
          />
        </td>
      </tr>
    ));

  return (
    <Page
      style={{ backgroundColor: "rgb(248, 248, 248)", padding: "20px 0px" }}
    >
      <div className="location-main">
        <h2 className="text-dark text-center">Employment History</h2>
        <Button
          title="Add Employment"
          primary={true}
          width="180px"
          style={{ marginLeft: "auto" }}
          onClick={() => setShowModal(true)}
        />
        <Table>
          <thead>
            <tr>
              <th>Employer</th>
              <th>Job Title</th>
              <th>Start Date</th>
              <th>End Date</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>{rows}</tbody>
        </Table>
        <NewEmployement
          opened={showModal}
          setOpened={setShowModal}
          setRefetch={setRefetch}
          editId={editId}
          editEmployment={editEmployment}
          setEditId={setEditId}
          isEdit={isEdit}
          setIsEdit={setIsEdit}
        />
      </div>
    </Page>
  );
};

export default withTranslation()(Index);
